// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Card: {
    select: 'เลือก',
    titleLinkTooltip: 'ไปที่หน้า',
    collapseCardTooltip: 'ย่อแผง',
    expandCardTooltip: 'ขยายแผง'
  },
  CardList: {
    loadMore: 'โหลดเพิ่ม',
    notFound: 'ไม่พบรายการใดๆ',
    toolbarSelect: 'เลือก',
    viewCards: 'แผง',
    viewTiles: 'หัวข้อ',
    viewList: 'รายการ',
    toolbarView: 'มุมมอง'
  },
  ClosingConfirmation: {
    confirm: 'ออก',
    cancel: 'กลับ',
    content: 'แน่ใจหรือไม่ว่าคุณต้องการปิดและออกจากหน้าต่างนี้? การเปลี่ยนแปลงข้อมูลใดๆ ที่คุณทำจะไม่ได้รับการบันทึก'
  },
  Cuttable: {
    showMore: 'แสดงเพิ่ม',
    showLess: 'แสดงน้อยลง'
  },
  Dialog: {
    cancelButton: 'ยกเลิก'
  },
  DrawerProgress: {
    cancelButton: 'ยกเลิก'
  },
  Dropdown: {
    close: 'ปิด'
  },
  Form: {
    submitButton: 'บันทึก',
    applyButton: 'ใช้',
    cancelButton: 'ยกเลิก'
  },
  FormField: {
    clear: 'ล้าง',
    remove: 'ลบ',
    addMore: 'เพิ่มอีกหนึ่งรายการ'
  },
  FormFieldPassword: {
    improvePassword: 'วิธีปรับปรุงความรัดกุมของรหัสผ่าน:',
    passwordTooShort: 'ตั้งรหัสผ่านให้ยาวๆ',
    lettersLowerCase: 'ใช้ตัวอักษรตัวเล็กอย่างน้อยหนึ่งตัว',
    lettersUpperCase: 'ใช้ตัวอักษรตัวใหญ่อย่างน้อยหนึ่งตัว',
    numbers1: 'ใช้ตัวเลขอย่างน้อยหนึ่งตัว',
    numbers3: 'ใช้ตัวเลขอย่างน้อยสามตัว',
    specialChar1: 'ใช้ตัวอักษรพิเศษอย่างน้อยหนึ่งตัว (เช่น: !, @, #, $, %, ^, &, *, ?, _, ~)',
    specialChar2: 'ใช้ตัวอักษรพิเศษอย่างน้อยสองตัว (เช่น: !, @, #, $, %, ^, &, *, ?, _, ~)',
    comboUpperAndLower: 'ใช้ทั้งตัวอักษรใหญ่และตัวอักษรเล็ก',
    comboLettersAndNumbers: 'ใช้ทั้งตัวเลขและตัวอักษร',
    comboLettersNumbersSpecial: 'ใช้ตัวเลข ตัวอักษร และตัวอักษรพิเศษ',
    yourPasswordIsStrong: 'คุณสามารถทำให้รหัสเดายากขึ้นด้วยการตั้งให้ยาวขึ้น',
    passwordStrength: 'ความรัดกุมของรหัสผ่าน %%strength%%',
    strengthVeryStrong: 'เดายากมาก',
    strengthStrong: 'เดายาก',
    strengthVeryWeak: 'เดาง่ายมาก',
    strengthWeak: 'เดาง่าย',
    strengthMedium: 'ปานกลาง',
    hidePassword: 'ซ่อนรหัสผ่าน',
    showPassword: 'แสดงรหัสผ่าน',
    generateButton: 'สร้างรหัสผ่าน',
    copyButtonHint: 'คัดลอกรหัสผ่าน',
    copySuccessToast: 'คัดลอกรหัสผ่านแล้ว',
    generateButtonHint: 'สร้างรหัสผ่านที่รัดกุม'
  },
  InPlaceEdit: {
    editButtonHint: 'แก้ไขค่า',
    okButtonHint: 'บันทึกการเปลี่ยนแปลง',
    cancelButtonHint: 'ละทิ้งการเปลี่ยนแปลง'
  },
  InputFile: {
    browseButton: 'เลือกไฟล์...'
  },
  List: {
    totalRows: 'รวม %%totalRows%% รายการ',
    selectedRows: 'เลือก %%selectedRows%% จาก %%totalRows%% รายการแล้ว',
    all: 'ทั้งหมด',
    allItemsOnPageSelected: 'เลือกรายการทั้งหมดบนหน้าแล้ว',
    allItemsSelected: 'เลือกรายการทั้งหมดแล้ว',
    selectAllItems: 'เลือกทุกรายการ',
    selectAllItemsOnPage: 'เลือกทุกรายการบนหน้า',
    deselectAll: 'ยกเลิกการเลือก'
  },
  ListEmptyView: {
    filteredTitle: 'ไม่พบรายการใดที่ตรงกับตัวกรอง',
    emptyTitle: 'ไม่พบอะไรในนี้',
    filteredDescription: 'ปรับการค้นหาของคุณใหม่และลบเกณฑ์บางชนิดจากตัวกรอง จากนั้นลองอีกครั้ง'
  },
  ListOperation: {
    cancelButton: 'ยกเลิก'
  },
  Pagination: {
    totalShort: 'จาก %%total%%',
    itemsPerPage: 'รายการต่อหน้า',
    all: 'ทั้งหมด',
    total: 'หน้า %%current%% จาก %%total%%'
  },
  ProgressDialog: {
    closeButton: 'ปิด',
    cancelButton: 'ยกเลิก'
  },
  Select: {
    noOptions: 'ไม่มีตัวเลือก',
    placeholder: 'เลือก...'
  },
  SpotPopup: {
    total: '%%current%% จาก %%total%%'
  },
  Toaster: {
    closeGroup: 'ปิดกลุ่ม'
  }
};